import { AppAction, Command } from '../config/appConfig'
import store from '../store'
import { BroadcastChannel } from 'broadcast-channel'

// Trigger a command dispatch by running postCommand({source: {id: 'test.AddTime'}})
// in https://app.hammock.nl/?context=command
const initializeCommands = () => {
    // Always required to be called.
    Office.onReady()
    commandChannel.addEventListener('message', handleCommand)

    // The add-in command functions need to be available in global scope.
    getGlobal().postCommand = (event: Office.AddinCommands.Event) => {
        const action: string = event.source?.id?.split('.')[1]
        console.log('banaan ' + event)

        if (action && Command[action]) {
            // Dispatch it to all channels, including ourself.
            commandChannel.postMessage(action)
            handleCommand(action)
        }

        if (event.completed) {
            // Be sure to indicate when the add-in command function is complete.
            event.completed()
        }
    }
}

const handleCommand = (action: string) =>
    store.dispatch({
        type: AppAction.DispatchCommand,
        payload: Command[action],
    })

export const getGlobal = (): any => {
    if (self !== undefined) {
        return self
    } else if (window !== undefined) {
        return window
    } else if (global !== undefined) {
        return global
    } else {
        return {}
    }
}

export const commandChannel = new BroadcastChannel<string>('commandChannel')

export default initializeCommands
